import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const GroupTreeServiceConfig = {
  name: "GroupTree",
  annotations: []
} as ServiceConfig;